import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Invoices } from '@/pages/invoices';
import { RoleGuard } from '@/components/molecules/role-guard';
import { usePermissions } from '@/hooks/use-permissions';
import { documentsSearchSchema } from '@/routes/protected/_layout/documents/_layout';

export const Route = createFileRoute('/protected/_layout/invoices/_layout')({
  validateSearch: documentsSearchSchema,
  component: InvoicesLayout,
});

function InvoicesLayout() {
  const { canAccessDocuments, isLoading } = usePermissions();

  return (
    <RoleGuard hasAccess={canAccessDocuments} isLoading={isLoading}>
      <Invoices />
      <Outlet />
    </RoleGuard>
  );
}
